import React from "react";
import { ArrowLeftRight, Binary, Database, FileCode, FileJson, FileText, GitCompare, Link2, Search } from "lucide-react";

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
    json: FileJson,
    xml: FileCode,
    yaml: FileText,
    sql: Database,
    diffchecker: GitCompare,
    jsonpath: Search,
    base64: Binary,
    url_encoder: Link2,
};

export function ToolIcon({ value, className = "w-4 h-4" }: { value: string; className?: string }) {
    const Icon = iconMap[value] ?? ArrowLeftRight;
    return <Icon className={className} aria-hidden="true" />;
}
